<template>
    <div>
        <i18n path="contacts.addModal.currentQR">
            <i class="text-muted">{{ expiration | formatDate }}</i>
        </i18n>
        <div class="row my-3">
            <div class="col-lg-3 mt-3 mt-lg-0">
                <qr-code class="qr-container" :size="100" :text="currentQR"></qr-code>
            </div>
            <div class="col-lg-3 mt-3 mt-lg-0">
                <router-link
                        class="btn btn-primary btn-block"
                        :to="{ name: 'ContactAddQR' }"
                >{{$t('contacts.addModal.scanQR')}}
                </router-link>
                <button
                        class="btn btn-primary btn-block"
                        :disabled="loading"
                        @click="getToken(true)"
                >{{$t('contacts.addModal.getQR')}}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import VueQRCodeGenerator from 'vue-qrcode-component';

export default {
    components: {'qr-code': VueQRCodeGenerator},

    computed: {
        ...mapGetters({
            loading: 'loading/loading/loading',
            token: 'contact/pair/token',
            expiration: 'contact/pair/expiration',
        }),
        currentQR: function () {
            return location.origin +
                '/' +
                this.$router.resolve({
                    name: 'ContactAddURL',
                    params: {token: this.token},
                }).href;
        },
    },
    methods: {
        getToken: function (force = false) {
            this.$store.dispatch('contact/pair/getToken', force);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/contact/PairScan.vue